import { render } from "./ParcelLookupForm.vue?vue&type=template&id=a4f27e88&scoped=true"
import script from "./ParcelLookupForm.vue?vue&type=script&lang=js"
export * from "./ParcelLookupForm.vue?vue&type=script&lang=js"

import "./ParcelLookupForm.vue?vue&type=style&index=0&id=a4f27e88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4f27e88"]])

export default __exports__